export default __webpack_public_path__ + "static/media/video.208fd557.mp4";